import React, { useState, useEffect } from "react";

import '../../assets/styles/CheckboxQuestion.css';

const CheckboxQuestion = ({ question, value = [], onChange }) => {

    const [cols, setCols] = useState("");
    // Sempre garantir que selected é um array
    const getSelectedArray = (val) => {
        if (Array.isArray(val)) return val;
        if (typeof val === 'object' && val?.items) return val.items;
        // Caso seja um objeto com chaves numéricas (ex: {0: 415, 1: 416, ...})
        if (typeof val === 'object' && val !== null && Object.keys(val).some(k => !isNaN(Number(k)))) {
            // Pega apenas os valores numéricos das chaves
            return Object.values(val).filter(v => typeof v === 'number');
        }
        return [];
    };
    const [selected, setSelected] = useState(() => getSelectedArray(value));

    useEffect(() => {
        setSelected(getSelectedArray(value)); // sincroniza quando volta pra seção
    }, [value]);

    const toggleOption = (ans_id) => {
        let updated = [];

        if (Array.isArray(selected) && selected.includes(ans_id)) {
            updated = selected.filter((id) => id !== ans_id);
        } else {
            updated = [...selected, ans_id];
        }

        setSelected(updated);

        // Propagar para o hook de respostas SEMPRE como array ou objeto esperado
        if (question.sym_for === 1) {
            const safeValue = Math.round((updated.length / question.answers.length) * 10);
            onChange({
                answer: safeValue,
                items: updated
            });
        } else {
            onChange([...updated]); // sempre array novo
        }
    };

    return (
        <div className="question checkbox-question py-4 py-lg-5">
            <div className="chat-message system">
                <h4 className="m-0" dangerouslySetInnerHTML={{ __html: question.label }}/>
                {question.sublabel && (<p className="mb-0 mt-1" dangerouslySetInnerHTML={{ __html: question.sublabel }}/>)}
            </div>
            <div className="chat-answer checkbox-list">
                <div className="row justify-content-start align-items-top">
                    {question.answers.map((option) => {
                        if(cols === ""){
                            setCols(option.label && option.label.length < 5 ? 'col-lg-4' : 'col-lg-6');
                        }
                        return (<div key={option.ans_id} className={`col-12 ${cols} pt-4`}>
                            <label className="row align-items-start">
                                <div className="col-auto pt-1">
                                    <input
                                        type="checkbox"
                                        checked={selected.includes(option.ans_id)}
                                        onChange={() => toggleOption(option.ans_id)}
                                    />
                                </div>
                                <div className="col ps-0">
                                    {option.label}
                                    {option.explain && (<small className="d-block mb-0 mt-1" dangerouslySetInnerHTML={{ __html: option.explain }}/>)}
                                </div>
                            </label>
                        </div>)
                        }
                    )}
                </div>
            </div>
        </div>
    );
};

export default CheckboxQuestion;
